import { render, staticRenderFns } from "./DeviceGroup.vue?vue&type=template&id=56b516c4&"
import script from "./DeviceGroup.vue?vue&type=script&lang=js&"
export * from "./DeviceGroup.vue?vue&type=script&lang=js&"
import style0 from "./DeviceGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports